import * as Auth from "./auth";
import * as Activity from "./activity";
import * as Notification from "./notification";
// import { GlobalBanner, actions as bannerActions } from "./banner";
import * as CostPackage from "./costpackege";
import * as Vendor from "./vendors";
import * as Voa from "./voa";
import * as VoaSummary from "./voa_summary";

import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { NeoImporter, NeoImporterList } from "./neo_importer";
import { PermisionRoute, RouteChangeWatcher } from "./utils";
import { PrivateRoute, UnsuporterPage } from "zina-dogi-react";
import React, { Component } from "react";

import BaseReport from "./utils/components/base_report"
import NonSode from "./non-sode";
import { QCModal } from "./qc";
import Sode from "./sode";
import { config, filterConfigByPerm } from "./menu.config";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import logo from "./assets/imgs/zina-india-logo-negativo.svg";

const minBrowserVersions = {
    chrome: "60",
    firefox: "55",
    edge: "15",
    'edge-chromium': '85',
};

const { detect } = require("detect-browser");
const cmp = require("semver-compare");

class Root extends Component {
    constructor(props) {
        super(props);
        this.state = {
            browser: null,
            supported: false,
            user: null
        };
    }

    componentDidMount() {
        this.onCheck(detect());
        this.setState({ user: this.props.user });
        // this.props.fetchMaintenanceAlert();
        if (this.props.user) this.props.fetchActiveAlert();
        this._onVisibilityChange = () => {
            if (document.visibilityState === "visible" && this.props.user) {
                this.props.fetchActiveAlert();
            }
        };
        document.addEventListener("visibilitychange", this._onVisibilityChange);
    }

    componentWillUnmount() {
        document.removeEventListener("visibilitychange", this._onVisibilityChange);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.user && this.props.user) {
            // this.props.fetchMaintenanceAlert();
            this.props.fetchActiveAlert();
        }
    }

    render() {
        const { browser, supported } = this.state;
        
        const extraProps = {
            ...this.props,
            // Menu config with onClick for QC Details
            config: this.props.config.map(item =>
                item.name === "QC Details"
                    ? { ...item, onClick: () => this.refs.qc && this.refs.qc.toggle() }
                    : item
            ),
            extraMenu: <Notification.NotificationAlertBadge />,
            userMenuItems: on_logout => <Auth.UserMenuItems onLogout={on_logout} />,
        }; 
        
        return (
            <div className="h-100">
                {/* <GlobalBanner /> */}
                <Notification.NotificationAlertViewer />
                <QCModal ref="qc" />
                {!supported && browser && <UnsuporterPage browser={browser} />}
                {supported && (
                    <BrowserRouter>
                    <>
                        {this.props.user && <RouteChangeWatcher onRouteChange={this.props.fetchActiveAlert} />}
                        <Switch>
                            <Route exact path="/login/" component={Auth.LoginContainer} />
                            <Route extraProps={extraProps} exact path="/login/oidc/" component={Auth.OIDCLogin} />
                            <Route
                                extraProps={extraProps}
                                exact
                                path="/login/validate/"
                                component={Auth.OIDCValidate}
                            />

                            <Route
                                extraProps={extraProps}
                                exact
                                path="/password-reset-confirm/:uid/:token/"
                                component={Auth.ResetPasswordConfirmContainer}
                            />
                            <Route
                                extraProps={extraProps}
                                exact
                                path="/password-recovery/"
                                component={Auth.PasswordRecoveryContainer}
                            />

                            <PermisionRoute
                                extraProps={extraProps}
                                exact
                                path="/activity/"
                                component={Activity.ActivityContainer}
                                codePerm="can_manage_activity_smp"
                            />
                            <PermisionRoute
                                extraProps={extraProps}
                                path="/activity/detail/:activityID/"
                                component={Activity.ActivityDetailContainer}
                                codePerm="can_manage_activity_smp"
                            />

                            <PermisionRoute
                                extraProps={extraProps}
                                exact
                                path="/notification/"
                                component={Notification.NotificationContainer}
                                codePerm='view_alert'
                            />

                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/"
                                component={Sode.cpo.CpoListContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/inbox/"
                                component={Sode.cpo.CpoListContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/cpo/pr-validation-report/"
                                component={Sode.cpo.PRValidationReportContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/cpo/cmn-report/"
                                component={Sode.cpo.CMNReportContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssot/cost-package-by-ssot-report/"
                                component={Sode.cpo.CostPackageBySSOTReportContainer}
                            />
                            <PermisionRoute
                                extraProps={extraProps}
                                exact
                                path="/cpo/report/"
                                component={Sode.cpo.CPOReportContainer}
                                codePerm="can_download_cpo_report"
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/detail/:cpoID/"
                                component={Sode.cpo.CpoDetailContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/detail/:cpoID/item/:cpoItemID/"
                                component={Sode.cpo.ItemDetailContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/detail/:cpoID/add_item/"
                                component={Sode.cpo.ItemDetailContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/cpo/upload/"
                                component={Sode.cpo.CPOUploaderContainer}
                            />

                            <PrivateRoute
                                extraProps={extraProps}
                                path="/tracker/:oetID/"
                                component={Sode.oet.OetTrackerContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/oetdashboardreport/"
                                component={Sode.oet.OetDashboardReportContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/oet-dashboard-report-bi/"
                                component={Sode.oet.OetDashboardReportBI}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/oet-run-report/"
                                component={NonSode.oet.OETRunReport}
                            />

                            <PrivateRoute
                                extraProps={extraProps}
                                path="/run/historic/report/"
                                component={Sode.run.RunReportContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/run/:oetID/:runID/"
                                component={Sode.run.RunDetailContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssot-web-form/:oetID/:runID/"
                                component={Sode.run.SSOTWebForm}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/sode/site-vs-run/report/"
                                component={Sode.run.SiteVsRunContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/sode/open_run_pendency/report/"
                                component={Sode.run.OpenRunVsPendencyContainer}
                            />
                            <PermisionRoute
                                extraProps={extraProps}
                                path="/sode/customer-capacity-plan/report/"
                                component={Sode.oet.CustomerCapacityPlanReportContainer}
                                codePerm="can_download_customer_capacity_plan_report"
                            />
                            <PrivateRoute
                                extraProps={{
                                    ...extraProps,
                                    base_options: {
                                        className: "bharti-approved-oet",
                                        title: "Bharti approved OET report",
                                        breadcrumbs: [
                                            { name: "Home", rel: "/", icon: "home" },
                                            { name: "Bharti approved OET report" }
                                        ]
                                    },
                                    report_component: Sode.oet.BhartiApprovedOetReport
                                }}
                                path="/sode/bharti-approved-oet/report/"
                                component={BaseReport}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/non-sode/"
                                component={NonSode.inbox.InboxContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/non-sode/dashboard-report/"
                                component={NonSode.dashboard_report.NonSodeDashboardReportContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/non-sode/:nonSodeID"
                                component={NonSode.inbox.DetailContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/non-sode/oet/:oetID/"
                                component={NonSode.oet.OetContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/non-sode/run/:oetID/:runID/"
                                component={NonSode.oet.RunContainer}
                            />

                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/master-budget/"
                                component={NonSode.master_budget.MasterBudgetContainer}
                            />

                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/vendors/"
                                component={Vendor.VendorContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/costpackage/"
                                component={CostPackage.CostPackageContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/costpackage/detail/:cpID/"
                                component={CostPackage.CostPackageDetailContainer}
                            />
                            <PrivateRoute extraProps={extraProps} exact path="/voa/" component={Voa.VoaContainer} />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/voa/detail/:voaID/"
                                component={Voa.VoaDetailContainer}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/voa-summary/"
                                component={VoaSummary.VoaSummaryContainer}
                            />

                            {/*<PrivateRoute extraProps={propsWithQC} exact path="/wbs/" component={Wbs.WbsContainer} />*/}
                            {/*<PrivateRoute extraProps={propsWithQC} path="/wbs/detail/:wbsID/" component={WbsDetail} />*/}

                            <PrivateRoute
                                extraProps={extraProps}
                                exact
                                path="/importers/list/"
                                component={NeoImporterList}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/costpackage/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/costpackageimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/voa/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/voaimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/wbs/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/wbsimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/good-receipt/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/goodreceiptimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/cpo-upload-importer/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/cpouploadimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/stp-master-data/importer"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/stpmasterdataimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/cpo-item-consumption-importer/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        url={`/importers/cpoitemconsumptionimporter/information/`}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/service-task-list-operation-importer/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        url={`/importers/servicetasklistoperationimporter/information/`}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/voa/sumary/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/voasummaryimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/voa/voa-case/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/voacaseimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/site/importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={`/importers/siteimporter/information/`}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/qc/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={`/importers/contractimporter/information/`} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/serviceorderitem/importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/serviceordertemplateimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssot-non-sode-importer/importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/ssotnonsodeimporter/information/"}
                                        customUrls={{ oet: "/non-sode/oet/", run: "/non-sode/run/" }}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssot-non-sode-cpm-importer/importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/ssotnonsodecpmimporter/information/"}
                                        customUrls={{ oet: "/non-sode/oet/", run: "/non-sode/run/" }}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/serviceorderitemomc/omc/importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/logisticomcimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/non-sode/ssot-omc-importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/logisticomcnonsodeimporter/information/"}
                                        customUrls={{ oet: "/non-sode/oet/", run: "/non-sode/run/" }}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/amend/importer/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/serviceordertemplateamendmentimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/siteomc/importer/omc/:oet/:run/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url="/importers/siteomcimporter/information/"
                                        test="Prueba de llamado"
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/serviceorderitem/cpm/importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/siteserviceordertemplateitemcpmimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/non-sode-ssot-cpm-importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        customUrls={{ oet: "/non-sode/oet/", run: "/non-sode/run/" }}
                                        url={"/importers/ssotcpmnonsodeimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/vendor/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={"/importers/vendorimporter/information/"} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/wiproimporter/"
                                component={props => (
                                    <NeoImporter {...props} url={"/importers/wiproimporter/information/"} />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/cpoitemimporter/:cpo/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["cpo"]}
                                        url={"/importers/cpoitemimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/cpo/blank-oet-received-date-importer/"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        url={"/importers/blankoetreceiveddateimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/pr-importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/primporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/pr-omc-importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/prvalidationomcimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssotbulk/importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/ssotbulkimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssotbulk/amend/importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/serviceordertemplatebulkamendmentimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssotbulk/cpm/importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/ssotbulkcpmimporter/information/"}
                                    />
                                )}
                            />
                            <PrivateRoute
                                extraProps={extraProps}
                                path="/ssotbulk/omc/importer/:oet/:run"
                                component={props => (
                                    <NeoImporter
                                        {...props}
                                        extraParamsRouter={["oet", "run"]}
                                        url={"/importers/logisticbulkomcimporter/information/"}
                                    />
                                )}
                            />
                            <PermisionRoute
                                extraProps={extraProps}
                                path="/activity/importer/"
                                component={props => (
                                    <NeoImporter {...props} url={"/importers/activitysmpimporter/information/"} />
                                )}
                                codePerm="can_manage_activity_smp"
                            />

                            <Redirect to="/" />
                            </Switch>
                    </>
                    </BrowserRouter>
                )}
            </div>
        );
    }

    onCheck = browser => {
        let supported = false;
        if (browser) {
            if (minBrowserVersions[browser.name]) {
                const version = minBrowserVersions[browser.name];
                const diff = cmp(browser.version, version);
                if (diff >= 0) {
                    supported = true;
                }
            }
        }
        this.setState({ browser, supported });
    };

}

const makeMapStateToProps = () => {
    const getFilteredConfig = createSelector(
        store => store.auth.user,
        user => filterConfigByPerm(config, user)
    );

    return store => {
        const user = store.auth.user;
        return {
            user,
            logo,
            config: getFilteredConfig(store)
        };
    };
};

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(Auth.actions.logOut()),
    // fetchMaintenanceAlert: () => dispatch(bannerActions.fetchMaintenanceAlert()),
    fetchActiveAlert: () => dispatch(Notification.actions.fetchActiveAlert())
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Root);
